import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { PropertyConstants } from 'enums/PropertyConstants';
import React, { ReactNode } from 'react';

export const PropertyIconMaps: Partial<Record<string, Record<string, ReactNode>>> = {
  [PropertyConstants.DefaultExplorerView]: {
    'List View (Default)': <RMSvgIcon name="ListView" />,
    'Content View': <RMSvgIcon name="ContentView" />,
    'Thumbnail View': <RMSvgIcon name="ThumbnailView" />,
    'Detail View': <RMSvgIcon name="DetailView" />,
  },
};

export const PropertiesWithIcons = new Set(Object.keys(PropertyIconMaps));
